import {useCallback, useEffect, useRef, useState} from "react";
import { HttpMethod, initFetch } from "../utils/fetcher";

const initialState = { documents: [], years: [], count: 0 };

const useYousignDocuments = (year) => {
  const [data, setData] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const abortRef = useRef(null);

  const fetchDocuments = useCallback(async () => {
    // annule la requête précédente si elle existe
    abortRef.current?.abort();
    const controller = new AbortController();
    abortRef.current = controller;

    setLoading(true);
    setError(null);

    try {
      const { url, params } = initFetch(`documents/yousign?year=${year}`, HttpMethod.GET);
      const response = await fetch(url, { ...params, signal: controller.signal });

      if (!response.ok) {
        throw new Error(`Erreur HTTP returned ${response.status}`);
      }

      const result = await response.json();

      if (!result.status) {
        throw new Error(`Erreur returned ${result.message}`);
      }

      setData({
        documents: result.documents,
        count: result.count,
        years: result.years,
      });
    } catch (e) {
      if (e.name === "AbortError") return;
      setError(e.message);
    } finally {
      if (!controller.signal.aborted) setLoading(false);
    }
  }, [year]);

  useEffect(() => {
    fetchDocuments().then();
    return () => abortRef.current?.abort();
  }, [fetchDocuments]);

  return {
    documents: data.documents,
    count: data.count,
    years: data.years,
    loading,
    error,
    fetchDocuments,
  };
};

export default useYousignDocuments;